// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer___2AyMk","sub":"sub___xYD39"};